// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2IF9r","options":"AnswerScale_options__3vFde","selected":"AnswerScale_selected__1hYy5"};